import type { CustomerAllocationGroupsModel } from './model/customerModel'
import Net from '@/services/net'

export function getCustomerAllocationGroups(catalogCode: number, customerId: number) {
  return Net.t1.get<CustomerAllocationGroupsModel>(`/catalogs/${catalogCode}/customers/${customerId}/assignallocationgroupstocustomers`)
}
